class CTCollectionSort {
  constructor(element) {
    this.element = element;
    this.trigger = element.querySelector(
      '[data-ct-sort-trigger]'
    );
    this.menu = element.querySelector(
      '[data-ct-sort-menu]'
    );

    if (!this.trigger || !this.menu) return;

    this.bindEvents();
  }

  bindEvents() {
    this.trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      this.toggle();
    });

    this.element
      .querySelectorAll('[data-ct-sort-value]')
      .forEach((option) => {
        option.addEventListener('click', () => {
          const sortValue =
            option.dataset.ctSortValue;

          if (!sortValue) return;

          const url = new URL(window.location.href);

          url.searchParams.set(
            'sort_by',
            sortValue
          );

          url.searchParams.delete('page');

          window.location.assign(url.toString());
        });
      });

    document.addEventListener('click', (event) => {
      if (!this.element.contains(event.target)) {
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close();
        this.trigger.focus();
      }
    });
  }

  toggle() {
    const shouldOpen = this.menu.hidden;

    this.menu.hidden = !shouldOpen;

    this.trigger.setAttribute(
      'aria-expanded',
      String(shouldOpen)
    );
  }

  close() {
    this.menu.hidden = true;

    this.trigger.setAttribute(
      'aria-expanded',
      'false'
    );
  }
}

function initCTCollectionSort() {
  document
    .querySelectorAll(
      '[data-ct-collection-sort]:not([data-ct-sort-initialized])'
    )
    .forEach((element) => {
      element.setAttribute(
        'data-ct-sort-initialized',
        'true'
      );

      new CTCollectionSort(element);
    });
}

document.addEventListener(
  'DOMContentLoaded',
  initCTCollectionSort
);

document.addEventListener(
  'shopify:section:load',
  initCTCollectionSort
);